import { Api } from '@/api';
import { ContentType, ProductType, UserLoginType } from '@/DTO';
import { ConvertToPublisherType } from '@/api/publisher';
import { ConvertToPricingType } from '@/api/pricing';
import { ConvertImageToContent } from '@/api/uploader';

export const GetProductById = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: ProductType;
  }>((resolve, reject) => {
    const api = new Api({
      method: 'get',
      path: `product/admin/${id}`,
      header: {
        Authorization: 'Bearer ' + user.accessToken,
        'Content-Type': 'application/json',
      },
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToProductType(data.data),
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToProductType = (item: any): ProductType => {
  return {
    id: item.id,
    title: item?.title,
    description: item?.description,
    language: item?.language,
    publish_date: item?.publish_date,
    author_name: item?.author_name,
    is_auto_price: item?.is_auto_price,
    status: item?.status,
    created_at: item?.created_at,
    paper_count: item?.paper_count,
    price: item?.price,
    offer: item?.offer,
    amount: item?.amount,
    category: item?.category,
    content: ConvertToContentList(item?.content),
    publisher: ConvertToPublisherType(item?.publisher),
    pricing: ConvertToPricingType(item?.pricing),
  };
};

export const ConvertToContentList = (data: any[]): ContentType[] => {
  return data.map((item) => {
    return ConvertImageToContent(item);
  });
};
